(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("survey-core"));
	else if(typeof define === 'function' && define.amd)
		define("bootstrap-integration", ["survey-core"], factory);
	else if(typeof exports === 'object')
		exports["bootstrap-integration"] = factory(require("survey-core"));
	else
		root["SurveyBootstrap"] = factory(root["Survey"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_survey_core__) {
return 